export default __webpack_public_path__ + "static/media/pdf.978163b3.svg";